import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Chart.svg",
  "use": "Chart.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Chart.svg\"><path d=\"M54.0208,52.0209h-44a2,2,0,0,1,0-4h44a2,2,0,0,1,0,4Zm-2-6h-8a2,2,0,0,1-2-2v-22a2,2,0,0,1,2-2h8a2,2,0,0,1,2,2v22A2,2,0,0,1,52.0208,46.0209Zm-16-34a2,2,0,0,1,2,2v30a2,2,0,0,1-2,2h-8a2,2,0,0,1-2-2v-30a2,2,0,0,1,2-2Zm-16,16a2,2,0,0,1,2,2v14a2,2,0,0,1-2,2h-8a2,2,0,0,1-2-2v-14a2,2,0,0,1,2-2Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol